import { booleanAttribute, ChangeDetectionStrategy, Component, input, numberAttribute } from '@angular/core';
import { MngColor } from './mng-icon.types';
import { ThemePalette } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mng-icon',
  imports: [MatIcon],
  templateUrl: './mng-icon.component.html',
  styleUrl: './mng-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MngIconComponent {
  readonly inline = input(false, { transform: booleanAttribute });

  readonly iconName = input.required<string>();

  readonly fontSize = input(24, { transform: numberAttribute });

  readonly color = input<MngColor>();

  getMatIconColor(color: MngColor): ThemePalette {
    if (
      color === 'warning' ||
      color === 'warn' ||
      color === 'error' ||
      color === 'primary' ||
      color === 'accent' ||
      color === 'info'
    ) {
      return <ThemePalette>color;
    } else {
      return undefined;
    }
  }
}
